export interface Config {
  dashboards: any;
  endpoints: any;
  bepActiveFlag: boolean;
  fepSpotActiveFlag: boolean;
  fepForwardsActiveFlag: boolean;
  fepNonLinearActiveFlag: boolean;
  repLinearActiveFlag: boolean;
  uploadValidationPollInterval: number;
  thoughtSpotHost: string;
  // Jitto Answer embed (ANS-545). Dashboards: config/jittoDashboards.json.
  jittoEmbedActiveFlag?: boolean;
  jittoEmbedOrigin?: string;
  // The embed SDK applies host filters (ANS-801): the currency picker shows with Jitto on.
  jittoHostFilters?: boolean;
}

export const env = process.env.REACT_APP_TPICAP_ENV
  ? process.env.REACT_APP_TPICAP_ENV
  : 'development';
const config = require(`./${env}`).default as Config;
export default config;
